import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay.tsx";
import useSocialLogins from "features/auth/useSocialLogins.ts";
import { OAuthPlatformType } from "@shared/types";
import useTelegramLogin from "features/auth/useTelegramLogin.ts";
import React, { useEffect } from "react";

const TelegramAuthPage = () => {
  const { onLoginClick } = useSocialLogins({
    openUrl: (url) => {
      window.open(url, "_self");
    },
    isAppSource: true,
  });
  useTelegramLogin();

  useEffect(() => {
    onLoginClick(OAuthPlatformType.TELEGRAM).catch(() => {});
  }, []);

  return <LoadingSpinnerOverlay isLoading={true} spinnerSize="large" />;
};

export default TelegramAuthPage;
